/**
 * model representing Angular form submission data for the inventory of
 * a type of relief/recovery item posssessed by an Organization
 */
export interface ReliefTypeFormData {
  typeId: number;
  itemCount: number;
}
